import React from "react";

const NotFound = () => {
  return (
    <div className="container" style={{ height: "80vh" }}>
      <h2 className="text-white h-100 fs-1 d-flex justify-content-center align-items-center">
        404 Not Found
      </h2>
    </div>
  );
};

export default NotFound;
